<div class="nav-container" role="banner">
  <!--<button mat-icon-button (click)="toggleLeftPanel()">
    <mat-icon>menu</mat-icon>
  </button>-->
  <div class="toggle-button">
    <app-map-panel-toggle-button></app-map-panel-toggle-button>
  </div>

  <div class="logo-wrapper" [routerLink]="['/' + RootRoute.MAIN]">
    <img class="logo__icon"
         [ngClass]="'logo__' + envName"
         src="assets/PlowOpsLogo_Snowflake.svg"
         [alt]="dashboardVersion"
         [matTooltip]="'PlowOps: ' + dashboardVersion"
    />
    <img class="logo__text"
         src="assets/plowops_logo_text_only.png"
         [alt]="dashboardVersion"
    />
  </div>

  <div class="nav-items" role="navigation">
    @if (configuration) {
      <app-search-bar
              [configuration]="configuration"
              [isCompact]="isCompact"
              (searchResulted)="onSearchResult($event)"
      ></app-search-bar>
    }

    <div class="weather-and-action-buttons">
      @if (configuration) {
        <app-storm-menu
          [configuration]="configuration"
        ></app-storm-menu>
      }

      @if (configuration && hasFeatureFlag(FeatureFlagEnum.Weather)) {
        <app-weather-news
          class="weather-news"
          [configuration]="configuration"
          [isCompact]="isCompact"
        >
        </app-weather-news>
      }

      <a mat-icon-button
         matTooltip="Open Support Documentation"
         matTooltipPosition="below"
         (click)="openSupportDocumentation()"
      >
        <mat-icon>help</mat-icon>
      </a>

      <button mat-icon-button
              [routerLink]="['/' + RootRoute.SETTINGS]"
              matTooltip="Settings"
              matTooltipPosition="below"
      >
        <mat-icon>settings</mat-icon>
      </button>
    </div>
  </div>

  @if (configuration) {
    <div class="account-block">
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="logout()">
          <mat-icon> login</mat-icon><span>Logout</span>
        </button>
      </mat-menu>
      <div [@opacityIn] class="account">
        <div class="account__tenant">
          {{ configuration.customerName }}
        </div>
        <button class="account__username mat-small" [matMenuTriggerFor]="menu">
          <div [matTooltip]="userName + ' <' + email + '>'" class="account__username__email">{{ email }}</div>
          <mat-icon class="account__username__icon">
            expand_more
          </mat-icon>
        </button>
      </div>
    </div>
  }
</div>
